import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="pagination">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <span
            onClick={() => onPageChange(currentPage - 1)}
            className="page-link cursor_pointer"
            aria-hidden="true"
          >
            &laquo;
          </span>
        </li>
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${number === currentPage ? "active" : ""}`}
          >
            <button className="page-link" onClick={() => onPageChange(number)}>
              {number}
            </button>
          </li>
        ))}
        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <span
            onClick={() => onPageChange(currentPage + 1)}
            className="page-link cursor_pointer"
            aria-hidden="true"
          >
            &raquo;
          </span>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
